import Vue from "vue";
import LocomotiveScroll from "~/libs/locomotive-scroll/plugin/index.js";

Vue.use(LocomotiveScroll);
